import { type AcademicNamespace, EmulateHeaders, queryClient } from '@tyro/api';
import { clearAllListNavigatorSettings } from '@tyro/core/hooks';

export const changeAcademicNamespace = (
  academicNamespace: AcademicNamespace,
) => {
  if (academicNamespace.isActiveDefaultNamespace) {
    localStorage.removeItem(EmulateHeaders.ACADEMIC_NAMESPACE_ID);
  } else {
    localStorage.setItem(
      EmulateHeaders.ACADEMIC_NAMESPACE_ID,
      String(academicNamespace.academicNamespaceId),
    );
  }

  clearAllListNavigatorSettings();
  queryClient.clear();
  window.location.reload();
};
